module.exports = __webpack_public_path__ + "media/images/front/brands/atelier/atelier_header_m-eb789d40d27ae3448e41bdc5e33fddf9.jpg";